import React, { useState } from 'react';
import { Share2, Copy, Check } from 'lucide-react';

/**
 * Konum paylaşma kutusu (WhatsApp / Google / Apple / Yandex / kopyala / cihaz paylaşımı).
 * item: { lat, lon, name, district, approx }
 */
export const KonumPaylas = ({ item, testIdPrefix = 'konum', compact = false }) => {
  const [kopyalandi, setKopyalandi] = useState(false);
  if (!item || !isFinite(item.lat) || !isFinite(item.lon)) return null;
  const lat = Number(item.lat).toFixed(6);
  const lon = Number(item.lon).toFixed(6);
  const gmaps = `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`;
  const baslik = [item.name, item.district].filter(Boolean).join(' — ');
  const metin = `${baslik}\n${lat}, ${lon}${item.approx ? ' (yaklaşık konum)' : ''}\n${gmaps}`;
  const links = [
    { id: 'whatsapp', label: 'WhatsApp', href: `https://wa.me/?text=${encodeURIComponent(metin)}` },
    { id: 'gmaps', label: 'Google Haritalar', href: gmaps },
    { id: 'apple', label: 'Apple Haritalar', href: `https://maps.apple.com/?ll=${lat},${lon}&q=${encodeURIComponent(item.name || 'Konum')}` },
    { id: 'yandex', label: 'Yandex Haritalar', href: `https://yandex.com.tr/maps/?ll=${lon},${lat}&z=17&pt=${lon},${lat}` },
  ];

  const kopyala = async () => {
    try {
      await navigator.clipboard.writeText(metin);
      setKopyalandi(true);
      setTimeout(() => setKopyalandi(false), 2000);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = metin;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        setKopyalandi(true);
        setTimeout(() => setKopyalandi(false), 2000);
      } catch { /* kopyalama desteklenmiyor */ }
      ta.remove();
    }
  };

  const cihazdanPaylas = () => navigator.share({ title: baslik, text: metin }).catch(() => {});
  const btn = 'text-[11.5px] px-2 py-1.5 rounded-lg border border-[#22344a] bg-[#101f31] text-[#a9bdd2] hover:text-white hover:border-[#3b5372] transition-colors';

  return (
    <div className={compact ? '' : 'mt-3 pt-3 border-t border-[#1b2c41]'} data-testid={`${testIdPrefix}-share-box`}>
      <div className="flex items-center gap-1.5 text-[10.5px] uppercase tracking-widest text-[#7d93ab] mb-2">
        <Share2 className="w-3 h-3" /> Konumu Paylaş
        {item.approx && <span className="normal-case tracking-normal text-amber-400/80">· yaklaşık konum</span>}
      </div>
      <div className={`grid gap-1.5 ${compact ? 'grid-cols-3' : 'grid-cols-2'}`}>
        {links.map((l) => (
          <a key={l.id} href={l.href} target="_blank" rel="noopener noreferrer" className={`${btn} text-center`} data-testid={`${testIdPrefix}-share-${l.id}`}>
            {l.label}
          </a>
        ))}
        <button onClick={kopyala} className={`${btn} inline-flex items-center justify-center gap-1.5`} data-testid={`${testIdPrefix}-share-copy`}>
          {kopyalandi ? <Check className="w-3 h-3 text-emerald-400" /> : <Copy className="w-3 h-3" />}
          {kopyalandi ? 'Kopyalandı' : 'Koordinatı Kopyala'}
        </button>
        {typeof navigator !== 'undefined' && navigator.share && (
          <button onClick={cihazdanPaylas}
            className="text-[11.5px] px-2 py-1.5 rounded-lg border border-amber-500/40 bg-amber-500/10 text-amber-300 hover:bg-amber-500/20 inline-flex items-center justify-center gap-1.5 transition-colors"
            data-testid={`${testIdPrefix}-share-native`}>
            <Share2 className="w-3 h-3" /> Diğer Uygulamalar
          </button>
        )}
      </div>
    </div>
  );
};

export default KonumPaylas;
